export default "__VITE_ASSET__47bad5ce__"